// extracted by mini-css-extract-plugin
export default {"footer":"XHYF_YJXN1tP0ihRdbHE"};